// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2100;
}

.sub-modal-card {
  width: min(740px, 100%);
  max-height: 90vh;
  overflow-y: auto;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 12px;
  padding: 32px 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  animation: subModalIn 0.2s ease;
}

@keyframes subModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.sub-modal-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sub-modal-header h2 {
  margin: 0;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 400;
  color: var(--color-text-primary);
}

.sub-modal-header p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 14px;
  line-height: 1.5;
}

/* ── Plan Cards Grid ── */
.sub-modal-plans {
  display: flex;
  gap: 14px;
}

.sub-modal-plan {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  padding: 22px 18px;
  background: var(--color-bg-canvas-surface);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.sub-modal-plan:hover {
  border-color: color-mix(in srgb, var(--color-accent-base) 40%, var(--color-border-input));
}

.sub-modal-plan--featured {
  border-color: var(--color-accent-base);
  box-shadow: 0 0 0 1px var(--color-accent-base), 0 10px 32px -14px rgba(15, 18, 24, 0.55);
}

.sub-modal-plan__badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--color-accent-base);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 3px 14px;
  border-radius: 20px;
  white-space: nowrap;
}

.sub-modal-plan__name {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 6px;
}

.sub-modal-plan__price {
  display: flex;
  align-items: baseline;
  gap: 3px;
  margin-bottom: 14px;
}

.sub-modal-plan__amount {
  font-size: 32px;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1;
}

.sub-modal-plan__period {
  font-size: 13px;
  color: var(--color-text-secondary);
}

.sub-modal-plan__features {
  list-style: none;
  padding: 0;
  margin: 0 0 18px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.sub-modal-plan__features li {
  font-size: 13px;
  color: var(--color-text-secondary);
  line-height: 1.4;
  padding-left: 18px;
  position: relative;
}

.sub-modal-plan__features li::before {
  content: "\\2713";
  position: absolute;
  left: 0;
  color: var(--color-accent-base);
  font-weight: 600;
  font-size: 12px;
}

.sub-modal-plan__features li strong {
  color: var(--color-text-primary);
}

/* ── Buttons ── */
.sub-modal-plan__btn {
  display: block;
  width: 100%;
  text-align: center;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border: none;
  font-family: inherit;
  transition: opacity 0.15s, transform 0.15s;
}

.sub-modal-plan__btn:hover:not(:disabled) {
  opacity: 0.88;
  transform: translateY(-1px);
}

.sub-modal-plan__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.sub-modal-plan__btn--primary {
  background: var(--color-accent-base);
  color: #fff;
}

.sub-modal-plan__btn--secondary {
  background: transparent;
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
}

.sub-modal-skip {
  display: block;
  margin: 0 auto;
  background: none;
  border: none;
  color: var(--color-text-secondary);
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  padding: 4px 8px;
  transition: color 0.15s;
}

.sub-modal-skip:hover {
  color: var(--color-text-primary);
}

/* ── Responsive ── */
@media (max-width: 700px) {
  .sub-modal-card {
    padding: 24px 16px 20px;
  }

  .sub-modal-plans {
    flex-direction: column;
  }

  .sub-modal-plan {
    padding: 18px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,sCAAsC;EACtC,wFAAwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".sub-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 2100;\n}\n\n.sub-modal-card {\n  width: min(740px, 100%);\n  max-height: 90vh;\n  overflow-y: auto;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 12px;\n  padding: 32px 28px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  animation: subModalIn 0.2s ease;\n}\n\n@keyframes subModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.sub-modal-header {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sub-modal-header h2 {\n  margin: 0;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(24px, 4vw, 32px);\n  font-weight: 400;\n  color: var(--color-text-primary);\n}\n\n.sub-modal-header p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* ── Plan Cards Grid ── */\n.sub-modal-plans {\n  display: flex;\n  gap: 14px;\n}\n\n.sub-modal-plan {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  padding: 22px 18px;\n  background: var(--color-bg-canvas-surface);\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.sub-modal-plan:hover {\n  border-color: color-mix(in srgb, var(--color-accent-base) 40%, var(--color-border-input));\n}\n\n.sub-modal-plan--featured {\n  border-color: var(--color-accent-base);\n  box-shadow: 0 0 0 1px var(--color-accent-base), 0 10px 32px -14px rgba(15, 18, 24, 0.55);\n}\n\n.sub-modal-plan__badge {\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--color-accent-base);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 3px 14px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.sub-modal-plan__name {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0 0 6px;\n}\n\n.sub-modal-plan__price {\n  display: flex;\n  align-items: baseline;\n  gap: 3px;\n  margin-bottom: 14px;\n}\n\n.sub-modal-plan__amount {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  line-height: 1;\n}\n\n.sub-modal-plan__period {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n.sub-modal-plan__features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 18px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.sub-modal-plan__features li {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n  padding-left: 18px;\n  position: relative;\n}\n\n.sub-modal-plan__features li::before {\n  content: \"\\2713\";\n  position: absolute;\n  left: 0;\n  color: var(--color-accent-base);\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.sub-modal-plan__features li strong {\n  color: var(--color-text-primary);\n}\n\n/* ── Buttons ── */\n.sub-modal-plan__btn {\n  display: block;\n  width: 100%;\n  text-align: center;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  border: none;\n  font-family: inherit;\n  transition: opacity 0.15s, transform 0.15s;\n}\n\n.sub-modal-plan__btn:hover:not(:disabled) {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.sub-modal-plan__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.sub-modal-plan__btn--primary {\n  background: var(--color-accent-base);\n  color: #fff;\n}\n\n.sub-modal-plan__btn--secondary {\n  background: transparent;\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n}\n\n.sub-modal-skip {\n  display: block;\n  margin: 0 auto;\n  background: none;\n  border: none;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-family: inherit;\n  cursor: pointer;\n  padding: 4px 8px;\n  transition: color 0.15s;\n}\n\n.sub-modal-skip:hover {\n  color: var(--color-text-primary);\n}\n\n/* ── Responsive ── */\n@media (max-width: 700px) {\n  .sub-modal-card {\n    padding: 24px 16px 20px;\n  }\n\n  .sub-modal-plans {\n    flex-direction: column;\n  }\n\n  .sub-modal-plan {\n    padding: 18px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
